import React, { useState, useEffect } from "react";
import { SidePopup } from "../../../components/model-popup/side-popup";
import { CustomButton } from "../../../components/buttons/button";
import TextIconInput from "../../../components/custom-fields/input";
import Table from "../../../components/table/table";

import SearchIcon from "../../../assets/icons/search-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { fetchSearchPatientList } from "../../../redux/slices/patientlookup.slice";

import { WordTitle } from "../../../utils/commonFunction";
import { toast} from "react-toastify";
import { ConfirmPopup } from "../../../components/model-popup/confirmation-popup";
import { UpdatePatientMappingAPI } from "../../../api/update";

export const PatientMapPopup = (props: any) => {
    const dispatch: any = useDispatch();
    const {
        showModal,
        setShowModal,
        handleClose,
        poupDetails,
        afterChangeNotesList,
    } = props;
    

    const [buttonLoader, setButtonLoader] = useState<boolean>(false);
    const [searchPatientName, setSearchPatientName] = useState<string|null>(null);
    const searchPatientList = useSelector(
        (state: any) => state.patientlookUp?.searchPatientList || []
    );
 
    const [mappedPatientDetails, setMappedPatientDetails] = useState<any>({})
 
    // table
    const [loader, setLoader] = useState<boolean>(true);
    const [page, setPage] = useState<number>(1);
    const [totalPage, setTotalPage] = useState<number>(1);
    const [sort, setSort] = useState<string>("lastName");
    const [sortDir, setSortDir] = useState<string>("asc");
    const [limit, ] = useState<number>(15);

    // confirm model
    const [showConfirmModel, setShowConfirmModel] = useState<boolean>(false);
    const [searchedDate, setSearchedDate] = useState<string|null>(null);
  const [showSearchPatientName, setShowSearchPatientName] = useState<string|null>(null);
    
    
    
    const [, setTotalRecord] = useState<number>(0);
    
    const handlePatientListData = (param:any = {}) => {
        const apiParam = {
            page:page,
            name: searchPatientName,
            sort: sort,
            sort_dir: sortDir,
            limit: limit,
            DOB: searchedDate
        }
    if ('page' in param) {
        setPage(param?.page);
        apiParam['page'] = param['page']
    }
    if ('sort' in param) {
        apiParam['sort'] = param['sort'];
        apiParam['sort_dir'] = param['sortDir'];
        apiParam['page'] = 1
        setSort(param['sort'])
        setSortDir(param['sortDir'])
        setPage(1)
    }
    if ('DOB' in param) {
        setSearchedDate(param['DOB']);
        apiParam['DOB'] = param['DOB'];
        apiParam['page'] = 1
        setPage(1)
    }
    if ('search' in param) {
        setSearchPatientName(param['search']);
        apiParam['name'] = param['search'];
        apiParam['page'] = 1
        setPage(1)
    }
    if(apiParam['page'] === 1){
        setLoader(true)
    }
    dispatch(
        fetchSearchPatientList(apiParam)
    ).then((res: any) => {
        setTotalPage(res?.payload?.total_pages);
          setTotalRecord(res?.payload?.total_count);
          setLoader(false);
        });
   }

   const handleNextPage = () => {
       handlePatientListData({'page':page + 1});
    };
    
    const setSelectedPatient = (row:any) => {
        setMappedPatientDetails(row)
    }

    const handleBirthDate = (value:string|null) => {

        if(value){
            handlePatientListData({'DOB':value})
        }else{
            handlePatientListData({'DOB':null})
        }
    }

    const updatePatientDetailConfirm = () => {
        if (mappedPatientDetails?.id) {
            if (mappedPatientDetails?.id === poupDetails?.patient_id) {
                toast.error("please map different patient");
                return
            }
            setShowConfirmModel(true)
        } else {
            toast.error("please map patient");
        }
    }
    
    const updatePatientDetail = async() => {
        setButtonLoader(true)
        const payload = {
            patient_id: mappedPatientDetails?.id
        }
        await UpdatePatientMappingAPI(poupDetails?.id,payload).then(async (res: any) => {
                if (res?.success) {
                  toast.success(res?.message);
                  setButtonLoader(false)
                  handlePatientListData({page:1})
                  setMappedPatientDetails({})
                  setShowConfirmModel(false)
                  setShowModal(false)
                  resetState()
                  afterChangeNotesList()
                } else {
                    toast.error(res?.message || res?.detail?.message || "Update patient details failed");
                    setButtonLoader(false)
                }
              })
    }

    const resetState = () => {
        setSearchedDate(null)
        setShowSearchPatientName(null)
        setSearchPatientName(null)
        setSort('lastName')
        setSortDir('asc')
    }


    
    useEffect(() => {
        if(showModal){
            handlePatientListData({page:1})
            setMappedPatientDetails({})
            setShowConfirmModel(false)
            resetState()
            setMappedPatientDetails({id:poupDetails?.patient_id,
                firstName:poupDetails?.patient_first_name,
                lastName:poupDetails?.patient_last_name,
                birthDate:poupDetails?.patient_birth_date,
                gender:poupDetails?.patient_gender,
                location:poupDetails?.location
            })
        }
     },[showModal])

     useEffect(() => {
        const handler = setTimeout(() => {
            handlePatientListData({ search: showSearchPatientName });
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [showSearchPatientName]);

    return (
        //eslint-disable-next-line
        //@ts-ignore

        <SidePopup
            showModal={showModal}
            handleClose={handleClose}
            width="max-w-[1000px]"
            title={'Update Map Patient'}
            closeIcon={false}
            footerStyle="flex justify-end gap-[16px] "
            footerContent={ showConfirmModel ? null :(
                    <>
                        <CustomButton
                            buttonStyle="text-[#031227] bg-white hover:bg-[#F5F5F5] disabled:bg-white disabled:text-[#AAADB1]  px-[26px] py-[12px] text-[14px] font-semibold leading-[17px] border-[#E8ECF4] "
                            buttonName="Cancel"
                            primary={false}
                            disable={buttonLoader}
                            onClick={() => {
                                    setShowModal(false);
                            }}
                        />
                        <CustomButton
                            type="submit"
                            loader={buttonLoader}
                            loaderStyle={`px-[40.5px] py-[13px] leading-[17px]`}
                            primary={true}
                            disable={buttonLoader}
                            buttonStyle="text-white px-[36px] py-[12px] text-[14px] font-semibold leading-[17px] hover:bg-[#166B5E] disabled:bg-[#75C8BB]  "
                            buttonName={"Update"}
                            onClick={() => {
                                updatePatientDetailConfirm();
                            }}
                        />
                    </>)
            }
        >
            

            <div
                className="pt-[1px]"
                
            >
                <div className="w-full h-[73vh] col-span-1 mb-[2px] grid grid-cols-[39%_59%] gap-1">
                    <div className="h-full p-2  border border-gray-200 rounded-lg shadow-sm">
                        <div className=" font-medium text-center my-2">Patient Details</div>
                        <hr className="my-2 shadow-md" />
                        <div className="grid grid-cols-[30%_70%] gap-y-12px]">
                            <div className=" font-medium">Patient :</div>
                            <div className=" max-w-[200px] truncate">
                        
                                <div>
                                {![null, "",undefined].includes(poupDetails?.source_last_name) && ![null, "",undefined].includes(poupDetails?.source_first_name)
                                    ? `${WordTitle(poupDetails?.source_last_name || '')}, ${WordTitle(poupDetails?.source_first_name || '')}`
                                    : (WordTitle(poupDetails?.source_last_name || '') || WordTitle(poupDetails?.source_first_name || ''))}
                                </div>
                        
                            </div>
                            <div className=" font-medium">Birthday :</div>
                            <div className=" max-w-[200px] truncate">{poupDetails?.source_birth_date ? poupDetails?.source_birth_date : ''}</div>
                            <div className=" font-medium">Gender :</div>
                            <div className=" max-w-[200px] truncate">{WordTitle(poupDetails?.source_gender ? poupDetails?.source_gender : '')}</div>
                        </div>
                        <div className="">
                            <hr className="my-2 shadow-md" />
                            <div className=" font-medium text-center my-2">Search Patient</div>
                            <hr className="my-2 shadow-md" />
                            <TextIconInput
                                placeholder="patient name"
                                label="Patient name"
                                divStyle=""
                                onChange={(e: any) => {
                                    if (setShowSearchPatientName)
                                         setShowSearchPatientName(e.target.value);
                                }}
                                inputStyle="w-full border-[#E8ECF4] border-[0.5px]
                                 rounded-[8px] !h-[48px]"
                                icon={SearchIcon}
                                value={showSearchPatientName?showSearchPatientName:''}
                                setShowSearch={setShowSearchPatientName}
                                clearSearch={()=>{
                                    setShowSearchPatientName('')
                                }}
                                iconStyle="w-[18px] h-[18px] bottom-[12px] right-[10px]
                                 border-none rounded-[0px]"
                            />

                            <TextIconInput
                                divStyle=""
                                label={"Date of birth"}
                                minLength={4}
                                placeholder="Patient date of brith"
                                maxLength={50}
                                name="DOB"
                                id="DOB"
                                inputStyle=" !h-[48px]"
                                value={searchedDate?searchedDate:''}
                                onChange={(e: any) => {
                                    handleBirthDate(e.target.value);
                                }}
                                type={"date"}
                            />

                        </div>
                        <div>
                            <hr className="my-2 shadow-md" />
                            <div className=" font-medium text-center my-2">Mapped Patient</div>
                            <hr className="my-2 shadow-md" />
                            <div className="grid grid-cols-[30%_70%] gap-y-12px]">
                                <div className=" font-medium">Patient :</div>
                                <div className=" max-w-[200px] truncate">
                            
                                    <div>
                                        {mappedPatientDetails && ![null, "",undefined].includes(mappedPatientDetails?.lastName) &&
                                                ![null, "",undefined].includes(mappedPatientDetails?.firstName)
                                                ? `${WordTitle(mappedPatientDetails?.lastName || '')}, ${WordTitle(mappedPatientDetails?.firstName || '')}`
                                                : (WordTitle(mappedPatientDetails?.lastName || '') || WordTitle(mappedPatientDetails?.firstName || '')) || ''}
                                    </div>
                            
                                </div>
                                <div className=" font-medium">Birthday :</div>
                                <div className=" max-w-[200px] truncate">{mappedPatientDetails?.birthDate ? mappedPatientDetails?.birthDate : ''}</div>
                                <div className=" font-medium">Gender :</div>
                                <div className=" max-w-[200px] truncate">{mappedPatientDetails?.gender ? WordTitle(mappedPatientDetails?.gender) : ''}</div>
                               
                            </div>
                        </div>
                    </div>
                    <div className="h-full p-2  border border-gray-200 rounded-lg shadow-sm">
                        <div className=" font-medium text-center my-2">Patient List</div>
                        <hr className="my-2 shadow-md" />
                        <Table
                            loading={loader}
                            data={searchPatientList}
                            tableScroll={"100%"}
                            sort={true}
                            Clickable={true}
                            rowClick={(row: any) => {
                            setSelectedPatient(row)
                            }}
                            pageSecondTableIndentifyClass="patientMapScrollableDiv"
                            hasNextPage={page < totalPage}
                            NextPageData={handleNextPage}
                            columns={[
                            "Patient",
                            "DOB",
                            "Gender"
                            ]}
                            sortTitleKeys={{
                            Patient: "lastName",
                            Gender: "gender",
                            }}
                            handleSortfunc={(key: any, value: any) => {
                                handlePatientListData({'sort':key,'sortDir':value})
                            }}
                            rowSpecificClass={(row: any) => row?.id === mappedPatientDetails?.id ? ' bg-[#EDF8F9] hover:!bg-[#d1f0ea]' : ''}
                            scopedSlots={{
                                Patient: ({ row }: any) => (
                                <td title={`${row?.lastName}, ${row?.firstName}`}>
                                    <div className=" max-w-[500px] truncate cursor-pointer">
                                    {WordTitle(row?.lastName)}, {WordTitle(row?.firstName)}
                                    </div>
                                </td>
                                ),
                                "DOB": ({ row }: any) => (
                                <td title={row?.birthDate || ""}>
                                    <div className=" max-w-[500px] truncate cursor-pointer">
                                    {row?.birthDate}
                                    </div>
                                </td>
                                ),
                                Gender: ({ row }: any) => (
                                <td title={row?.gender || ""}>
                                    <div className=" max-w-[500px] truncate cursor-pointer">
                                    {WordTitle(row?.gender)}
                                    </div>
                                </td>
                                ),
                                Location: ({ row }: any) => (
                                <td title={row?.location || ""}>
                                    <div className=" max-w-[500px] truncate cursor-pointer">
                                    {WordTitle(row?.location)}
                                    </div>
                                </td>
                                )
                            }}
                        />
                    </div>

                </div>
                <ConfirmPopup showModal={showConfirmModel} icon>
                    <div className="text-[16px] font-semibold text-center text-[#061018] line-height-[24px]">
                    Map Patient?
                    </div>
                    <div className="text-[12px] font-normal text-center text-[#061018] mt-[8px] mb-[16px] ">
                    <div className="grid grid-cols-[30%_max-content_max-content] gap-y-10px  text-left">
                        <div className=" font-medium">Patient :</div>
                        <div className=" max-w-[200px] truncate">
                    
                            <div>
                            {![null, "",undefined].includes(poupDetails?.patient_last_name) && ![null, "",undefined].includes(poupDetails?.patient_first_name)
                                        ? `${WordTitle(poupDetails?.patient_last_name || '')}, ${WordTitle(poupDetails?.patient_first_name || '')}`
                                        : (WordTitle(poupDetails?.patient_last_name || '') || WordTitle(poupDetails?.patient_first_name || ''))}
                            </div>
                    
                        </div>
                        <div className=" max-w-[200px] truncate">
                    
                            <div>
                                <span className="font-semibold mx-2">to</span> {mappedPatientDetails && ![null, "",undefined].includes(mappedPatientDetails?.lastName) &&
                                        ![null, "",undefined].includes(mappedPatientDetails?.firstName)
                                        ? `${WordTitle(mappedPatientDetails?.lastName || '')}, ${WordTitle(mappedPatientDetails?.firstName || '')}`
                                        : (WordTitle(mappedPatientDetails?.lastName || '') || WordTitle(mappedPatientDetails?.firstName || '')) || ''}
                            </div>
                    
                        </div>
                        <div className=" font-medium">Birthday :</div>
                        <div className=" max-w-[200px] truncate">{poupDetails?.source_birth_date ? poupDetails?.source_birth_date : ''}</div>
                        <div className=" max-w-[200px] truncate"> <span className="font-semibold mx-2">to</span> {mappedPatientDetails?.birthDate ? mappedPatientDetails?.birthDate : ''}</div>
                        <div className=" font-medium">Gender :</div>
                        <div className=" max-w-[200px] truncate">{ WordTitle(poupDetails?.source_gender ? poupDetails?.source_gender : '')}</div>
                        <div className=" max-w-[200px] truncate"> <span className="font-semibold mx-2">to</span> {WordTitle(mappedPatientDetails?.gender ? mappedPatientDetails?.gender : '')}</div>
                    </div>
                    <div className="mt-2">
                        Are you sure you want to continue?
                    </div>
                    </div>
                    <div className="flex justify-center gap-[16px] items-center w-full">
                    <CustomButton
                        buttonName="Cancel"
                        primary={false}
                        buttonStyle="w-full text-[#1C252D] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px] hover:bg-gray-200  "
                        disable={buttonLoader}
                        onClick={() => {
                        setShowConfirmModel(false);
                        }}
                    />
                    <CustomButton
                        buttonName="Yes"
                        primary={true}
                        buttonStyle="w-full text-white  hover:bg-[#166B5E] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
                        loader={buttonLoader}
                        disable={buttonLoader}
                        loaderStyle="w-full bg-[#F5F5F5]/80  py-[13px] "
                        onClick={() => {
                            updatePatientDetail()
                            setShowConfirmModel(false)
                        }}
                    />
                    </div>
                </ConfirmPopup>
            </div>

        </SidePopup>
        
    );
};
